import Vue from 'vue';
import VueI18n from 'vue-i18n';

import Element from 'element-ui';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

Vue.use(VueI18n);

const modulesFiles = require.context('./temp', true, /\.json$/);
// 可配置自定义的
const messages = { en: { ...enLocale }, zh: { ...zhLocale } };

modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath);
  const { en, zh } = value;
  messages.en = { ...messages.en, ...en };
  messages.zh = { ...messages.zh, ...zh };
}, {});

const i18n = new VueI18n({
  locale: localStorage.getItem('ipp_lang') || 'zh', // 设置语言类型    navigator.language // 获取浏览器的语言
  messages,
  fallbackLocale: 'zh',
  legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
  globalInjection: true, // 全局注册$t方法
  silentTranslationWarn: true // 去除国际化警告
});

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
});

export default i18n;
